import { initTabSystem } from './utils/tabs';
import { initTimeline } from './utils/timeline';

document.addEventListener('DOMContentLoaded', function () {
  // ─── Environmental Slider Tabs (environmental.php) ───────────────────────
  initTabSystem({
    tabsContainerSelector: '#environmental-tabs',
    panelsContainerSelector: '#environmental-content',
    tabSelector: '.environmental-pillar__tab',
    panelSelector: '.environmental-pillar__panel',
    titleSelector: '#environmental-title',
  });

  // ─── Environmental Goals Timeline (social.php) ───────────────────────────
  const { observeAnimateItems } = initTimeline({
    timelineSelector: '.environmental-timeline',
    prefix: 'environmental-timeline',
  });

  if (observeAnimateItems) {
    const animateItems = document.querySelectorAll(
      '.environmental-timeline__item[data-animate], .environmental-timeline__mobile-item[data-animate]',
    );
    observeAnimateItems(animateItems, true);
  }
});
